// AvvisoRete.tsx — fascia in alto che dice cosa sta succedendo con la rete, con "Riprova".
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { StatoImpostazioni } from "../servizi/impostazioni.ts";

function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const su = () => setOnline(true);
    const giu = () => setOnline(false);
    window.addEventListener("online", su);
    window.addEventListener("offline", giu);
    return () => {
      window.removeEventListener("online", su);
      window.removeEventListener("offline", giu);
    };
  }, []);
  return online;
}

export function AvvisoRete({ server, onRiprova }: { server: StatoImpostazioni; onRiprova: () => void }) {
  const { t } = useTranslation();
  const online = useOnline();

  let messaggio: string | null = null;
  const codice = server.errore?.codice;
  // Limitato o bloccato: niente "Riprova" (ogni tentativo allungherebbe l'attesa); l'app riprova da sola.
  const limitato = codice === "bloccato" || codice === "troppe_richieste";
  if (!online) messaggio = t("rete.offline");
  else if (limitato) messaggio = t("rete.bloccato");
  else if (server.errore && codice !== "manutenzione") messaggio = t("rete.server", { secondi: server.riprovaTraSecondi });
  if (!messaggio) return null;

  return (
    <div className="avviso" role="status" aria-live="polite">
      <span>{messaggio}</span>
      {online && !limitato && (
        <button type="button" className="pulsante pulsante-piccolo" onClick={onRiprova}>
          {t("rete.riprova")}
        </button>
      )}
    </div>
  );
}
